/** @format */

import clutch_dark from "./clutch-dark.png";

const Brands = { clutch_dark };

export default Brands;
